// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number, boolean, any } from "@altostra/type-validations/lib/primitives";

export const isCanvasStepsResult = arrayOf(
  objectOf({
    type: string,
    workflow_step_name: string,
    step_id: string,
    workflow_id: string,
    app_group_id: string,
    next: arrayOf(string),
    row: number,
    column: number,
    is_head_step: boolean,
    created: string,
    step_data: any,
  })
);
